import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    width: 80px;
    height: 120px;
    margin-bottom: 20px;
  }

  input {
    width: 300px;
  }
`;
